export const SERVER_CONNECTED = "SERVER_CONNECTED";
export const SERVER_DISCONNECTED = "SERVER_DISCONNECTED";
export const GET_EVENTS_REQUEST = "GET_EVENTS_REQUEST";
export const GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS";
export const CHECK_TICKET_REQUEST = "CHECK_TICKET_REQUEST";
export const CHECK_TICKET_SUCCESS = "CHECK_TICKET_SUCCESS";